import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/book")({
  beforeLoad: () => {
    throw redirect({
      to: "/kitaplar/yapay-zeka-gucun-iki-yuzu",
      statusCode: 301,
    });
  },
});
